class DropDownVariants extends HTMLElement {
  constructor() {
    super();

    this.productForm = document.querySelector(
      `form[id="${this.dataset.formId}"]`,
    );

    this.productField = this.productForm.querySelector(
      "input[name='product-id']",
    );
    this.variantField = this.productForm.querySelector("input[name='id']");
    this.submitButton = this.productForm.querySelector("button[type='submit']");

    // button click event
    this.select = this.querySelector("select");
    this.select.addEventListener("change", this.handleSelectChange.bind(this));

    //this.addEventListener("click", this.handleSelectChange.bind(this));

    this.json = this.querySelector(".yc-product-variants-json");
    this.variants = JSON.parse(this.json.innerHTML).variants;
  }

  handleSelectChange(event) {
    console.log("Variant selected:", this.select.value);
    console.log("Available variants:", this.variants);

    if (this.select.value) {
      const variant = this.variants.find(
        (variant) => variant.id === Number(this.select.value),
      );

      const productId = this.dataset.productId;

      this.variantField.value = variant.id;
      this.productForm.querySelector("input[name='quantity']").value = 1;
      this.productField.value = productId;

      if (this.submitButton) {
        const variantPrice = variant.price;
        this.submitButton.querySelector(".button-price").innerHTML =
          variantPrice;

        if (variant.available) {
          this.submitButton.removeAttribute("disabled");
          this.submitButton.querySelector(
            ".yc-product-card__button-label",
          ).innerHTML = "Add to cart";
        } else {
          this.submitButton.setAttribute("disabled", true);
          this.submitButton.querySelector(
            ".yc-product-card__button-label",
          ).innerHTML = "Sold out";
        }
      }

      // update URL
      if (this.dataset.productUrl) {
        const newUrl = `${this.dataset.productUrl}?variant=${variant.id}`;
        window.history.replaceState({ path: newUrl }, "", newUrl);
      }
    }
  }

  setValue(value) {
    this.select.value = value;
    this.handleSelectChange();
  }

  getValue() {
    return {
      productId: this.productField.value,
      variantId: this.variantField.value,
    };
  }
}

customElements.define("yc-dropdown-variants", DropDownVariants);
